const spinner = {
    spinner:  undefined,
    template: `<div id="loading-spinner" class="loading-spinner">
                <svg class="loading-spinner__image" xmlns="http://www.w3.org/2000/svg"  version="1.0" width="60px" height="60px" viewBox="0 0 128 128" xml:space="preserve">
                    <g>
                        <path d="M64 128A64 64 0 0 1 18.34 19.16L21.16 22a60 60 0 1 0 52.8-17.17l.62-3.95A64 64 0 0 1 64 128z" fill="#000000"/>
                        <animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="2200ms" repeatCount="indefinite"></animateTransform>
                    </g>
                </svg>
            </div>`,
    append($element) {
        $element.append(this.template);
        this.spinner = $('#loading-spinner');
    },
    visibility(visible = false) {
        if (visible) {
            this.spinner.fadeIn(200);
        } else {
            this.spinner.fadeOut(200);
        }
    }
};

// DOM ready
$(() => {
    spinner.append($('body'));
});

export default spinner;
